import { ENV_VARIABLES } from '@/constants';

/**
 * Both credentials are required together: RUM needs the pair, and Logs needs
 * the client token, so a partial configuration starts nothing.
 */
const hasDatadogCredentials = (): boolean =>
  Boolean(ENV_VARIABLES.DATADOG_APP_ID && ENV_VARIABLES.DATADOG_CLIENT_TOKEN);

export default hasDatadogCredentials;
